export default ({ authGuard, guestGuard }) => [
  // Authenticated routes.
  ...authGuard([
    { path: '/', name: 'home', component: () => import('../views/Home.vue') },
    { path: '/notifications', name: 'notifications', component: () => import('../views/Notifications.vue') },
    { path: '/forms/new', name: 'form.overview.new', meta: { indexType: 'new' }, component: () => import('../views/form/FormOverview.vue') },
    { path: '/forms/started', name: 'form.overview.started', meta: { indexType: 'started' }, component: () => import('../views/form/FormDataOverview.vue') },
    { path: '/forms/saved', name: 'form.overview.saved', meta: { indexType: 'saved' }, component: () => import('../views/form/FormOverview.vue') },
    { path: '/forms/sent', name: 'form.overview.sent', meta: { indexType: 'sent' }, component: () => import('../views/form/FormDataOverview.vue') },
    { path: '/forms/sync', name: 'form.overview.sync', meta: { indexType: 'sync' }, component: () => import('../views/form/FormDataSyncOverview.vue') },
    { path: '/chat/:id', name: 'form.chat', component: () => import('../views/form/show/Chat.vue') },
    {
      path: '/form/:id',
      component: () => import('../views/form/FormShow.vue'),
      children: [
        { path: 'overview', name: 'form.show', component: () => import('../views/form/show/Overview.vue') },
        { path: 'chat', name: 'form.show.chat', component: () => import('../views/form/show/Chat.vue') },
        { path: 'instruction', name: 'form.show.instruction', component: () => import('../views/form/show/Instruction.vue') },
        { path: 'head', name: 'form.show.head', component: () => import('../views/form/show/HeadForm.vue') },
        { path: 'main', name: 'form.show.main', component: () => import('../views/form/show/MainForm.vue') },
        { path: 'validate', name: 'form.show.validate', component: () => import('../views/form/show/Validate.vue') }
      ]
    }
  ]),

  // Guest routes.
  ...guestGuard([
    { path: '/login', name: 'login', component: () => import('../views/auth/Login.vue') },
    { path: '/password/reset', name: 'password.request', component: () => import('../views/auth/password/Email.vue') },
    { path: '/password/reset/:token', name: 'password.reset', component: () => import('../views/auth/password/Reset.vue') },
    { path: '/password/reset/:token/:email', name: 'password.reset.email', component: () => import('../views/auth/password/Reset.vue') }
  ]),

  { path: '/ext/form/preview', name: 'form.ext.preview', component: () => import('../views/form/show/ExternalPreview.vue') },
  { path: '/ext/form/:id/:code', name: 'form.ext', component: () => import('../views/form/show/External.vue') },
  { path: '/ext/form/:id', name: 'form.ext.public', component: () => import('../views/form/show/External.vue') },
  { path: '/ext/form/:id/sent', name: 'form.sent', component: () => import('../views/form/show/Sent.vue') },
  { path: '/index.html', redirect: '/' },
  { path: '*', component: () => import('../views/errors/404.vue') }
];
